import { Pipe, PipeTransform } from '@angular/core';
import { LicenseDetails } from '../models/LicenseDetails.model';
@Pipe({
  name: 'licenseFilter'
})
export class LicenseFilterPipe implements PipeTransform {

  transform(licenseData: LicenseDetails[], searchTerm: string): LicenseDetails[] {
    if (!licenseData || !searchTerm) { return licenseData; }
    return licenseData.filter(a =>
      a.LicenseNo.toLowerCase().indexOf(searchTerm.toLowerCase()) !== -1
   

    );
  }

}
